import { documentTypeUtils } from '@wix/santa-editor-utils';

export default {
  pinnable: false,
  allowConnectToDB: true,
  skipInQuickEditPanel: true,
  supportedInCurrentDocument: () =>
    !documentTypeUtils.isCurrentDocumentTypeIsFluidDocument(),
};
